// Every enquiry form on the site — the quote wizard and the contact form — hands
// its details to the mail service through here, so the endpoint, the address the
// business is notified on, and the failure handling are defined once.
//
// TODO: ENQUIRY_ENDPOINT is still the dev host. Point it at the production endpoint
// before go-live — enquiries sent through this one do not reach the business.
export const ENQUIRY_ENDPOINT = 'https://api-yc365-dev-sa.azurewebsites.net/api/User/SendEmailToUser';

const NOTIFY_TO_ADDRESS = 'liam@catesroofing.com';
const FROM_ADDRESS = 'yc365@yourcare365.com';

/**
 * Mirrors the API's ServiceRequestEmailContract. The three non-optional fields are
 * non-nullable server-side, so they are always sent — omitting one would fail model
 * validation rather than arrive blank. A visitor who leaves only a phone number (or
 * only an email) still submits successfully; the unused one goes over as ''.
 *
 * The contract carries no subject or source field, so any form with extra context
 * folds it into additionalNotes rather than inventing a property the API drops.
 */
export type EnquiryPayload = {
  fullName: string;
  phoneNumber: string;
  emailAddress: string;
  propertyAddress?: string;
  city?: string;
  roofAge?: string;
  roofType?: string;
  squareFootage?: string;
  serviceNeeded?: string;
  urgency?: string;
  additionalNotes?: string;
};

/** POST an enquiry. Resolves when the service accepted it, throws otherwise. */
export async function sendEnquiryEmail(payload: EnquiryPayload): Promise<void> {
  const response = await fetch(ENQUIRY_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      fullName: payload.fullName.trim(),
      phoneNumber: payload.phoneNumber.trim(),
      emailAddress: payload.emailAddress.trim(),
      notifyToAddress: NOTIFY_TO_ADDRESS,
      fromAddress: FROM_ADDRESS,
    }),
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(text || `Request failed with status ${response.status}`);
  }
}

/** Message to show when a send fails, falling back when the error carries no detail. */
export const enquiryErrorMessage = (err: unknown, fallback: string): string =>
  err instanceof Error && err.message ? err.message : fallback;
